// extracted by mini-css-extract-plugin
export default {"qrInput":"ScanQRView_qrInput__BfcRt","texth":"ScanQRView_texth__yjp0H","text":"ScanQRView_text__ATNL8","footer":"ScanQRView_footer__g4ZWg","center":"ScanQRView_center__V3N-s"};